/* @generated */
import * as React from "react";
import { contentIconRecipe } from "../styles/index.css.esm.js";
import classNames from "classnames";
import { useThemedStyle } from "../hooks/useThemedStyle.esm.js";
import { BackgroundFileSmall } from "./_background/background-file-small.esm.js";
import { useCompositeContentIconViewBox } from "../hooks/useContentIconViewbox.esm.js";
const FilePhotoshopSmall = ({
  className,
  hasWhitespace = true,
  over = "base",
  hasBackground = true,
  ...props
}) => {
  const cls = classNames([
    "dig-ContentIcon",
    className,
    "dig-ContentIcon--small",
    {
      "dig-ContentIcon--overBase": over === "base",
      "dig-ContentIcon--overSubtle": over === "subtle",
      "dig-ContentIcon--hasNoBackground": !hasBackground
    },
    contentIconRecipe({ over, hasNoBackground: !hasBackground })
  ]);
  const style = useThemedStyle({ over });
  const viewBox = useCompositeContentIconViewBox({ hasWhitespace, size: "small" });
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      viewBox,
      fill: "none",
      role: "presentation",
      focusable: "false",
      width: 40,
      height: 40,
      className: cls,
      "data-testid": "FilePhotoshopSmall",
      style,
      ...props
    },
    hasBackground ? /* @__PURE__ */ React.createElement(BackgroundFileSmall, null) : null,
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M9.74 13.88c1.88.01 2.78-.96 2.78-2.46C12.52 9.99 11.6 9 9.69 9H7v7.13h1.29v-2.25h1.45Zm-.05-3.76c1.02 0 1.52.53 1.52 1.3 0 .87-.54 1.34-1.49 1.34H8.29v-2.64h1.4Zm6.113 6.16c1.69 0 2.5-.81 2.5-1.92 0-1.29-1.15-1.51-2.18-1.66-.83-.12-1.57-.19-1.57-.72 0-.4.26-.69 1.07-.69.76 0 1.14.25 1.23.81h1.34c-.16-1.14-.92-1.86-2.56-1.86-1.58 0-2.37.77-2.37 1.82 0 1.29 1.15 1.51 2.18 1.66.82.12 1.56.19 1.56.72 0 .46-.33.74-1.17.74-.81 0-1.29-.27-1.41-.95h-1.42c.17 1.33 1.04 2.05 2.8 2.05Z",
        fill: "#0070E0"
      }
    )
  );
};
export {
  FilePhotoshopSmall
};
